import { render, staticRenderFns } from "./ExchangeBuilding.vue?vue&type=template&id=566d1681&"
import script from "./ExchangeBuilding.vue?vue&type=script&lang=js&"
export * from "./ExchangeBuilding.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeBuilding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports